import "../components/receipt/receipt.css";
import { useEffect, useRef } from "react";
import Receipt from "../components/receipt/Receipt";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { resetCart } from "../redux/cart";
const ReceiptPrinting = () => {
  const store = useSelector((state) => state.store.Store);
  const dispatch = useDispatch();
  const { cart, tendered, payment_method, purchaser } = useSelector(
    (state) => state.cart
  );
  const receiptRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    contentRef: receiptRef,
    onAfterPrint: () => dispatch(resetCart()),
  });
  useEffect(() => {
    handlePrint();
  }, [handlePrint]);
  return (
    <div className="print-receipt-container">
      <button
        className="back-to-dashboard"
        onClick={() => {
          dispatch(resetCart());
          window.location.href = "/";
        }}
      >
        back to dashboard
      </button>
      <Receipt
        store={store}
        items={cart}
        ref={receiptRef}
        tendered={tendered}
        payment_method={payment_method}
        purchaser={purchaser}
      />
      ;
    </div>
  );
};

export default ReceiptPrinting;
